export const CHAT_MESSAGES_PAGINATION_LIMIT = 20;
